import * as React from 'react';
import Box from '@mui/material/Box';
import Slider from '@mui/material/Slider';

export default function MinAndMaxSlider({min = 1, max = 80}) {

  const valuesList = Array.from({length: max})
  const values = valuesList.map((valuseL, index) => {
    return {
      value: (index * 10),
      label: (index * 10),
    }
  })


  return <Box sx={{paddingRight: 2}}>
    <Slider
      aria-label="Min and max values"
      min={min}
      max={max}
      defaultValue={20}
      step={1}
      valueLabelDisplay="auto"
      marks={values}
    />
  </Box>
}